import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { FaLock } from 'react-icons/fa';
import Lottie from 'lottie-react';
import lockAnimation from '../../lockAnimation/Animation - 1748590452292.json';
import '../../../assets/css/Unauthorized/Unauthorized.css'; // custom CSS for background

const Unauthorized = () => {
  return (
    <div className="unauthorized-bg">
      <Container className="d-flex justify-content-center align-items-center min-vh-100 text-center">
        <Row>
          <Col>
            <div className="bg-white p-5 rounded shadow-lg border animated-card">
              <div className="mb-4" style={{ width: 200, margin: '0 auto' }}>
                <Lottie animationData={lockAnimation} loop={true} />
              </div>
              <h1 className="text-danger fw-bold">
                <FaLock className="me-2" />
                403 - Unauthorized
              </h1>
              <p className="text-muted fs-5">You do not have permission to access this page.</p>
              <Button variant="danger" href="/" className="mt-3 px-4">
                Go to Home
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Unauthorized;
